import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface HelpBreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function HelpBreadcrumb({ items }: HelpBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-1.5 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <ChevronRight
                className="h-4 w-4"
                style={{ color: 'var(--text-muted)' }}
              />
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:underline transition-colors"
                style={{ color: 'var(--text-secondary)' }}
              >
                {item.label}
              </Link>
            ) : (
              <span style={{ color: 'var(--text-primary)' }}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
